<template>
    <div class="zoom-selector" :class="orientation">
        <div class="slider-title">
            <div class="label">{{ $translate('zoom') }}</div>
            <div class="value">X{{ zoom }}</div>
        </div>

        <div class="zoom-selector-slider">
            <div class="ticks-container">
                <span>X1</span>
                <span>X2</span>
                <span>X3</span>
            </div>

            <b-form-slider
                :orientation="orientation"
                :value="zoom"
                :min="1"
                :max="3"
                :step="0.1"
                :reversed="orientation === 'vertical'"
                @change="setZoom"
            />
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
    name: 'ZoomSelector',
    props: {
        orientation: {
            type: String,
            default: 'vertical'
        }
    },
    computed: {
        ...mapState({
            focusedWell: state => state.timelapse.focusedWell,
            playState: state => state.video.playState
        }),
        zoom() {
            return this.focusedWell.zoom
        }
    },
    methods: {
        setZoom(event) {
            this.$log.videoEvent('zoom_changed', {
                fromZoom: this.zoom,
                toZoom: event.newValue,
                playState: this.playState,
                method: 'slider'
            })

            this.$store.commit('timelapse/wellZoom', event.newValue)
        }
    }
}
</script>

<style lang="scss" scoped>
.zoom-selector {
    display: flex;
    flex-direction: column;

    .slider-title {
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        font-size: 9pt;
        color: $light-4;
        background-color: $dark-4;
        border-radius: $border-radius;

        .label,
        .value {
            display: flex;
            align-items: center;
            justify-content: center;
            padding: 0.25rem;
        }

        .label {
            border-right: 0.1rem solid $dark-2;
        }
    }

    .zoom-selector-slider {
        position: relative;
        display: grid;
        width: 100%;

        .ticks-container {
            display: flex;
            justify-content: space-between;
            font-size: 9pt;
            color: $light;
        }
    }

    &.horizontal {
        .slider-title,
        .zoom-selector-slider {
            height: 60px;
        }

        .slider-title {
            font-size: 12pt;

            .value {
                font-weight: 600;
            }
        }

        .zoom-selector-slider {
            grid-template-rows: repeat(2, 1fr);

            .ticks-container {
                align-items: flex-end;
            }
        }

        @media screen and #{$new-break2close} {
            display: grid;
            column-gap: 20px;
            grid-template-columns: 1fr 2fr;
        }
    }

    &.vertical {
        .zoom-selector-slider {
            grid-template-columns: repeat(3, 1fr);
            column-gap: 0.5rem;
            padding-top: 0.25rem;
            margin-top: 1rem;

            .ticks-container {
                flex-direction: column-reverse;
                text-align: right;
            }
        }
    }
}
</style>

<style lang="scss">
.zoom-selector {
    .slider {
        &.slider-horizontal,
        &.slider-vertical {
            .slider-track,
            .slider-track-low,
            .slider-track-high,
            .slider-selection {
                background-image: none;
            }

            .slider-handle {
                background: $blue;
                width: 1.5rem;
                height: 1.5rem;
                border-radius: 50%;
                cursor: pointer;
                border: 0.4rem solid $dark-4;
                box-shadow: $handle-shadow;
                z-index: 20;

                &:hover {
                    border-color: $dark-5;
                }
            }
        }

        &.slider-horizontal {
            width: 100%;

            .slider-track {
                height: 0.5rem;
                width: 100%;
                background-color: $dark-3;
            }
            .slider-handle {
                top: -0.2rem;
            }
        }

        &.slider-vertical {
            height: $video-left-control-height;

            .slider-track {
                width: 0.5rem !important;
                background-color: $dark-4;
            }
            .slider-handle {
                margin-left: -0.2rem;
            }
        }
    }
}
</style>
